module.exports = __webpack_public_path__ + "static/media/DownloadIcon.75dbab57.svg";